var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScythe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M632.58 11.625C626.58 4.25 617.455 0 607.957 0H338.852C191.986 0 63.996 64 0 224H552.086L538.711 288H407.971C394.717 288 383.973 298.746 383.973 312S394.717 336 407.971 336H528.838L495.965 483.621C492.922 498.262 504.1 512 519.051 512C530.213 512 539.846 504.172 542.131 493.242L639.453 38C641.203 28.625 638.703 19 632.58 11.625ZM561.959 176H78.619C134.865 91 221.982 48 338.852 48H588.582L561.959 176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScythe);
export default __webpack_public_path__ + "static/media/scythe.fd6aff74d0955220cc91401b58e7d328.svg";
export { ForwardRef as ReactComponent };